import React from "react";
import { RecipientForm } from "./recipient-form";

type Props = { onRecipientAdded: (recipient: { name: string; email: string }) => void; }


export const AddNativeESignatureBlockControlPanel = ({ onRecipientAdded }: Props) => {
  return <RecipientForm onRecipientAdded={onRecipientAdded} />
}